import React from 'react';
import './Join.css';

const Join = () => {
  return (
    <div className="join">
      <h1>加入我们</h1>
      <div className="join-cards">
        <div className="join-card">
          <div className="card-icon">💬</div>
          <h3>QQ群</h3>
          <p>群号: 1085847352</p>
          <button onClick={() => { navigator.clipboard.writeText('1085847352'); alert('QQ群号已复制！'); }} className="btn-primary">
            复制群号
          </button>
        </div>
        <div className="join-card">
          <div className="card-icon">💖</div>
          <h3>爱发电</h3>
          <p>支持我们的服务器</p>
          <a href="https://afdian.com/a/Longtengminecraft" target="_blank" rel="noopener noreferrer" className="link-button">
            前往爱发电
          </a>
        </div>
        <div className="join-card">
          <div className="card-icon">📺</div>
          <h3>哔哩哔哩</h3>
          <p>关注我们的账号</p>
          <a href="https://space.bilibili.com/3493142716221442" target="_blank" rel="noopener noreferrer" className="link-button">
            前往B站
          </a>
        </div>
      </div>
    </div>
  );
};

export default Join;
